import orderBy from 'lodash/orderBy';
import { trackEventConstant } from "../../plugins/analytics.constant";

// noinspection JSAnnotator
export const contentDirectoryPageConstant = {
    label: {
        CONTENT_DIRECTORY_TITLE: 'Content Directory',
        SELECT_CATEGORIES_TITLE: 'Select one or more categories to refine your results',
        SORT_BY: 'Sort by ',
        NETWORKS: "Networks",
        DIRECTORY_TEXT_LENGTH: 80,
        MORE_CHAPTERS: "More",
        CLEAR_ALL: 'Clear All',
        NO_RESULT_FOUND: 'Sorry no contents found',
        DEFAULT_TYPE_AHEAD_LABEL: 'WHAT ARE YOU INTERESTED TO SEE?',
        DEFAULT_SUB_FILTER_LABEL: 'PLEASE SELECT ONE OR MORE OPTIONS FROM FOLLOWING',
        NO_TYPE_AHEAD_RESULT_FOUND: 'No results found',
        SAVE: 'Save',
        SEE_VOUCHERS: 'See all the contents that accept vouchers',
        CONTENT_DIRECTORY_SUB_TITLE: 'Select one or more categories to refine your results.',
        SECONDARY_FILTER_LABEL_DEFAULT: 'PLEASE SELECT ONE OR MORE FROM FOLLOWING?',
        PARTICIPANTS_ONLY: 'Participants Only',
        VIEW_FULL_CONTENT_DIRECTORY: 'view the full Content Directory',
        NEWS_FEED: 'Newsfeed',
        FILES_AND_MEDIA: 'Files & Media',
    },
    constant: {
        searchResultOffsetStep: 50,
        searchResultMaxCount: 50,
        minimumCountForRolodex: 10,
        filesAndMedia: 'Files And Media',
        post: 'Post',
        folderMediaType: 'Folder',
        home: 'home',
        contentpagevtrackarray: [
            trackEventConstant.COMPONENT.CONTENT_DIRECTORY_SEARCH_PAGE,
            trackEventConstant.ENTITY.ROLODEX,
            trackEventConstant.ACTION.FILTER_CONTENT_BY_LETTER,
        ],
        Resources: 'resources',
        PnPContentName: 'bylaws, policies and procedures',
        contentDateComponent: 'ContentDate',
    },
    errors: {
        FROM_DATE_REQUIRED: 'From date required',
        TO_DATE_REQUIRED: 'To date required',
        FROM_DATE_BEFORE_TO_DATE: "To date should be after from date!",
    },
};

export const contentRibbonTitles = [
    {
        name: 'Community Type',
        key: 'communityType',
        component: 'ContentCommunityType',
        active: false,
        label: 'FIND CONTENT FROM ONE OR MORE OF THESE COMMUNITY TYPES',
    },
    {
        name: 'Content Category',
        key: 'contentType',
        component: 'ContentCategory',
        active: false,
        label: 'ARE YOU LOOKING FOR SPECIFIC TYPES OF CONTENT?',
    },
    {
        name: 'Date',
        key: 'dates',
        component: 'ContentDate',
        active: false,
        label: 'REFINE YOUR RESULTS BY DATE',
    },
];

export const createContentState = () => {
    const state = {};
    if (contentRibbonTitles && contentRibbonTitles.length > 0) {
        contentRibbonTitles.forEach((item) => {
            state[item.key] = [];
        });
    }
    return state;
};

export const contentSortOptions = [
    {
        label: 'Date (Most Recent)',
        key: 'startDateTime_desc',
        sortField: 'Date',
        direction: 'desc',        
    },
    {
        label: 'Name',
        key: 'contentName_asc',
        sortField: 'Title',
        direction: 'asc', 
    },
];

export const defaultContentSort = contentSortOptions[0];

export const buildSearchObjectByParam = (content, contentSearchText) => {
    return {
        name: content.communityType.toLowerCase(),
        params: {
            communityId: content.communityId ? content.communityId : null,
        },
        query: {
            postId: content.contentId,
            highlightText: contentSearchText,
            showAllActivityFeedCommunity: 'true',
        },
    };
};

export const handleSelectedContent = (content, contentSearchText, router, downLoadFolder, isMobileApp) => {
    if (
        content.contentType.toLowerCase() === contentDirectoryPageConstant.constant.Resources.toLowerCase() &&
        content.contentName.toLowerCase() === contentDirectoryPageConstant.constant.PnPContentName.toLowerCase()
    ) {
        router.push(openPoliciesAndProcedures());
    } else if (
        content.contentType.toLowerCase() !== contentDirectoryPageConstant.constant.filesAndMedia.toLowerCase() &&
        content.contentType.toLowerCase() !== contentDirectoryPageConstant.constant.post.toLowerCase()
    ) {
        window.open(content.url, isMobileApp ? '_self' : '_blank');
    } else if (
        content.contentType.toLowerCase() === contentDirectoryPageConstant.constant.post.toLowerCase() &&
        content.communityType.toLowerCase() === contentDirectoryPageConstant.constant.home.toLowerCase()
    ) {
        router.push(buildSearchObjectByParam(content, contentSearchText));
    } else if (content.contentType.toLowerCase() === contentDirectoryPageConstant.constant.post.toLowerCase()) {
        router.push(buildSearchObjectByParam(content, contentSearchText));
    } else {
        const element = {
            communityId: content.communityId,
            isFolder:
                content.mediaType.toLowerCase() === contentDirectoryPageConstant.constant.folderMediaType.toLowerCase(),
            id: content.contentId,
            name: content.contentName,
        };
        downLoadFolder(element).then(() => {});
    }
};
